import { render, staticRenderFns } from "./LicensingKanban.vue?vue&type=template&id=f49a4810&scoped=true&"
import script from "./LicensingKanban.vue?vue&type=script&lang=js&"
export * from "./LicensingKanban.vue?vue&type=script&lang=js&"
import style0 from "./LicensingKanban.vue?vue&type=style&index=0&id=f49a4810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49a4810",
  null
  
)

export default component.exports